var AbstractFavouritesEditView = require("./AbstractFavouritesEditView");
var Utils = require("common/Utils");

/**
 *
  * @class
 * @extends AbstractFavouritesEditView
 */
function RemoveFavouritesView() {
    AbstractFavouritesEditView.call(this);

    var self = this;
    var $removeButton = $('<a href="#" data-role="button" data-icon="mobile-confirm" data-iconpos="notext" data-inline="true">');

    /**
     * @override
     * @inheritDoc
     */
    this.getHashName = function() {
        return "RemoveFavourites";
    };

    $removeButton.on("click", function() {
        // Figure out what has been selected
        var resources = [];
        self.getContent().find(".favSelectionMarker").closest("li").each(function() {
            resources.push($(this).attr("data-resource-id"));
        });

        self.publishEvent("FavouritesController", "remove-favourites", {resources : resources});
    });

    var super_getHeaderConfiguration = this.getHeaderConfiguration;
    /**
     * @override
     * @inheritDoc
     */
    this.getHeaderConfiguration = function() {
        return $.extend(super_getHeaderConfiguration(), {
            title : $.t("common::favourites.delete.description"),
            i18n : "common::favourites.delete.description",
            rightButtons : [$removeButton],
            additionalClasses : "remove"
        });
    };

    /**
     * @override
     * @inheritDoc
     */
    this.onResourceItemClick = function(e) {
        e.preventDefault();
        e.stopPropagation();

        var $li = $(e.target).closest("li");
        $li.toggleClass("favSelectionMarker remove");
        Utils.setElementEnabled($removeButton, self.getContent().find(".favSelectionMarker").size() > 0);
    };

    var super_show = this.show;
    /**
     * @override
     * @inheritDoc
     */
    this.show = function() {
        Utils.setElementEnabled($removeButton, false);

        super_show.call(this);
    };
}

Utils.inherits(RemoveFavouritesView, AbstractFavouritesEditView);

module.exports = RemoveFavouritesView;


//////////////////
// WEBPACK FOOTER
// ./favourites/RemoveFavouritesView.js
// module id = 75
// module chunks = 0